<template>
  <el-card>
    <div slot="header">
      <h1 class="has-operation">
        <span>公司列表</span>
        <el-button-group>
          <router-link :to="{ name: 'company-company-create'}">
            <el-button type="primary" icon="el-icon-plus">创建公司</el-button>
          </router-link>
        </el-button-group>
      </h1>
    </div>
    <div class="flex row">
      <el-input v-model.trim="query.value" placeholder="请输入"  style="width:300px">
        <el-select v-model="query.type" slot="prepend"  style="width:110px" >
          <el-option label="公司名称" value="name"></el-option>
          <el-option label="邮箱后缀" value="email"></el-option>
        </el-select>
      </el-input>
      <el-button style="margin-left:10px;" type="primary" @click="setFilterAndQuery">查询</el-button>
    </div>
    <el-table class="table block" v-loading="loading" :data="collection">
      <el-table-column prop="name" label="公司名称" />
      <el-table-column prop="updatedAt" label="更新时间" :formatter="$tableHelper.fmts.date" />
      <el-table-column prop="emailSuffix" label="邮箱后缀" />
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">

          <router-link :to="{ name: 'company-company-staff', params: { id: scope.row.id }}">
            <el-button type="text">员工管理</el-button>
          </router-link>

          <Divider type="vertical" />

          <router-link :to="{ name: 'company-company-edit', params: { id: scope.row.id }}">
            <el-button type="text">编辑</el-button>
          </router-link>

          <Divider type="vertical" />
          <el-button type="text" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :pagination="pagination" :changed="queryCollection" />
  </el-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const { mapGetters } = createNamespacedHelpers('companies')
  import Divider from '../../components/Divider/index'

  export default {
    data() {
      return {
        loading: false,
        query: {
          type: 'name',
          value: ''
        },
        filter: {}
      }
    },
    components: {
      Divider
    },
    computed: {
      ...mapGetters(['collection', 'total', 'pagination']), // 映射必要数据
    },
    methods: {
      setFilterAndQuery() {
        const filter = {}
        if (this.query.value) {
          if (this.query.type == 'name') {
            filter.name = `%${this.query.value}%`
          } else if (this.query.type == 'email') {
            filter.emailSuffix = `%${this.query.value}%`
          }
        }
        this.filter = filter
        this.queryCollection()
      },
      async queryCollection({ pagination = { limit: 10 } } = {}) {
        try {
          this.loading = true
          await this.$store.dispatch('companies/collection', { pagination, query: this.filter })
        } finally {
          this.loading = false
        }
      },
      async remove(company) {
        await this.$confirm('确认要删除此公司？')
        await this.$store.dispatch('companies/remove', company)
        await this.queryCollection()
        this.$message.success('公司删除操作完成')
      }
    },
    mounted() {
      this.queryCollection()
    },
    activated() {
      this.queryCollection()
    }
  }
</script>
